export class StockQuantity{
    currentFreeProductQuantity: number;
    orderPromotionTrackings: any[];
}


// WEBPACK FOOTER //
// ./src/app/customerservice/interface/stock-quantity.ts